import type { Contact, User } from 'types'

export const toAuthorized = (u: User) => ({
  id: u.id ?? u.user_uuid ?? '',
  contact_id: u.panda_contact_id ?? u.contact_id ?? '',
  email: u.email ?? '',
  first_name: u.first_name ?? u.firstName ?? '',
  last_name: u.last_name ?? u.lastName ?? '',
  role: 'Authorized Personnel',
  signing_order: 1,
})

export const toClient = (c: Contact) => ({
  id: c.contacts_uuid ?? c.id ?? c.contact_id ?? '',
  contact_id: c.panda_contact_id ?? c.contact_id ?? c.contacts_uuid ?? '',
  email: c.email ?? '',
  first_name: c.first_name ?? c.firstName ?? '',
  last_name: c.last_name ?? c.lastName ?? '',
  role: 'Client',
  signing_order: 1,
})
